// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap);"]);
// Module
exports.push([module.id, "* {\r\n    margin: 0;\r\n    padding: 0;\r\n    outline: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n    font: 440 14px Roboto, sans serif;\r\n    -webkit-font-smoothing: antialiased;\r\n    background: #f0f0f5;\r\n}\r\n\r\nbutton {\r\n    cursor: pointer;\r\n}", ""]);
// Exports
module.exports = exports;
